import * as React from 'react';
import clsx from 'clsx';
import { Typography } from '@/components/common';
import { CaseDetailsCardProps } from '@/interfaces';

export const CaseDetailsCard: React.FC<CaseDetailsCardProps> = ({
	title,
	pill,
	accent = 'none',
	disabled,
	className,
	classNameHeader,
	classNameBody,
	children,
}) => {
	const titleId = React.useId();

	return (
		<section
			aria-labelledby={titleId}
			className={clsx(
				'relative flex flex-col overflow-hidden rounded-3xl bg-white',
				disabled
					? '!bg-bg-disabled border border-[#0D061614]'
					: 'shadow-shadow2',
				className
			)}
		>
			{accent === 'danger' && (
				<span
					aria-hidden="true"
					className="absolute inset-y-0 left-0 w-1.5 bg-main-red"
				/>
			)}
			<header
				className={clsx(
					'flex items-center justify-between gap-3 px-[18px] pt-[22px] lg:px-7 lg:pt-7',
					classNameHeader
				)}
			>
				<div className="flex min-w-0 items-center gap-2">
					{accent !== 'none' && (
						<span
							aria-hidden="true"
							className={clsx('h-2 w-2 shrink-0 rounded-full', {
								'bg-main-red': accent === 'danger',
								'bg-main-green': accent === 'success',
							})}
						/>
					)}
					<Typography
						id={titleId}
						type="semibold-14"
						className="break-words uppercase tracking-wide"
					>
						{title}
					</Typography>
				</div>
				{pill}
			</header>
			<div
				className={clsx(
					'flex min-h-0 flex-1 flex-col px-[18px] pb-[22px] lg:px-7 lg:pb-7',
					classNameBody
				)}
			>
				{children}
			</div>
		</section>
	);
};
